import { useRouteMatch } from 'react-router-dom';

export default function useMatchedChannelPage() {
  const matchedChannelPage = useRouteMatch({
    path: ['/channel/:channelId(\\d+)', '/channel/:channelId(\\d+)/genre/:genreToken?'],
    exact: true,
  });

  return {
    channelId: matchedChannelPage?.params.channelId, 
    isChannelPage: Boolean(matchedChannelPage),
  }
}